import React from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { endImpersonation } from '../../store/slices/authSlice';

/** Fixed banner shown for the duration of a platform-owner "login as tester" session. */
export default function ImpersonationBanner() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { impersonatedBy, user } = useSelector((state) => state.auth);
  const [exiting, setExiting] = React.useState(false);

  if (!impersonatedBy) return null;

  const handleExit = async () => {
    setExiting(true);
    try {
      await dispatch(endImpersonation()).unwrap();
      toast.success('Returned to your own account');
      navigate('/app/admin', { replace: true });
    } catch (error) {
      toast.error('Could not restore your session — please log in again');
      navigate('/login', { replace: true });
    } finally {
      setExiting(false);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: '#7c2d12',
        color: '#fff',
        px: 2,
        py: 0.75,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
        fontSize: '0.8125rem',
      }}
    >
      <Typography sx={{ fontSize: 'inherit', fontWeight: 600 }}>
        Viewing as {user?.firstName} {user?.lastName} ({user?.email}) — impersonated by {impersonatedBy.firstName || impersonatedBy.email}
      </Typography>
      <Button
        size="small"
        onClick={handleExit}
        disabled={exiting}
        sx={{
          bgcolor: '#fff',
          color: '#7c2d12',
          fontWeight: 700,
          textTransform: 'none',
          px: 1.5,
          py: 0.25,
          minHeight: 0,
          '&:hover': { bgcolor: '#fef2f2' },
        }}
      >
        {exiting ? <CircularProgress size={14} sx={{ color: '#7c2d12' }} /> : 'Exit impersonation'}
      </Button>
    </Box>
  );
}
